exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".u-margin-top-35px{margin-top:35px !important}.u-margin-top-20px{margin-top:20px !important}.u-inline-links a:not(:first-child){border-left:1px solid #898a8d}.u-inline-links a{padding:0 10px}.u-list-2-columns ul{column-count:2;column-gap:45px;text-align:left;width:fit-content}.u-bg-solid--brand{background:#88f1c7}.u-padding-y-5vh{padding-top:5vh;padding-bottom:5vh}.u-padding-y-10vh{padding-top:10vh;padding-bottom:10vh}.u-width-full{width:100%}", ""]);

// exports
